import requestTypes from './requestTypes';

const initialState = {
    loading: false,
    requests: [],
};

const requestReducer = (state = initialState, action: any) => {
    let nextState;

    switch (action.type) {
        
        case requestTypes.SAVE_REQUEST:
            nextState = {
                ...state,
                loading: true,
            };
            return nextState || state;
        
        case requestTypes.SAVE_REQUEST_DONE:
            nextState = {
                ...state,
                loading: false,
            };
            return nextState || state;
        
        case requestTypes.GET_REQUESTS:
            nextState = {
                ...state,
                loading: true,
            };
            return nextState || state;

        case requestTypes.SET_REQUESTS:
            nextState = {
                ...state,
                requests: action.payload,
                loading: false,
            };
            return nextState || state;
        
        default:
            return state;
    }
};

export default requestReducer;
